import { useEffect } from 'react';
import { useAppSelector } from '@store/store.tsx';
import { applySiteTypographyToDom } from '../typography/siteTypography';

export function useApplySiteTypography() {
  const typography = useAppSelector((state) => state.settings.site?.site_typography);

  useEffect(() => {
    applySiteTypographyToDom(typography);
  }, [typography]);
}
